<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/cooperationList' }">合作规划</el-breadcrumb-item>
                <el-breadcrumb-item>合作规划{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                        <el-form-item label="code：" prop="code" v-if="type == 1">
                            <el-input v-model="ruleForm.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作方：" prop="partner_name">
                            <el-select
                                v-model="ruleForm.partner_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入合作方搜索"
                                :remote-method="remotePartner"
                                :loading="partnerLoading"
                                size="mini"
                                clearable
                                @change="partnerChange"
                            >
                                <el-option v-for="item in partnerOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品：" prop="product_name">
                            <el-select
                                v-model="ruleForm.product_name"
                                placeholder="请输入选择产品名称"
                                clearable
                                filterable
                                size="mini"
                                @change="productChange"
                            >
                                <el-option v-for="item in productOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品代码：" prop="product_code" v-if="type == 1">
                            <div class="read_only_link read_only" @click="productClick(ruleForm.product_rid)">
                                {{ ruleForm.product_code }}
                            </div>
                        </el-form-item>
                        <el-form-item label="省份：" prop="province_name">
                            <el-select
                                v-model="ruleForm.province_name"
                                placeholder="请选择省份"
                                clearable
                                @change="provinceChange"
                                filterable
                                size="mini"
                            >
                                <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市：" prop="city_name">
                            <el-select
                                v-model="ruleForm.city_name"
                                placeholder="请选择城市"
                                clearable
                                filterable
                                size="mini"
                                @change="cityChange"
                            >
                                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="特征码：" prop="feature_code" v-if="type == 1">
                            <el-input
                                clearable
                                v-model="ruleForm.feature_code"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间：" prop="start_date">
                            <el-date-picker
                                v-model="ruleForm.start_date"
                                type="date"
                                placeholder="请选择开始时间"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                @change="startChange"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间：" prop="end_date">
                            <el-date-picker
                                v-model="ruleForm.end_date"
                                type="date"
                                placeholder="请选择结束时间"
                                format="yyyy-MM-dd"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                @change="endDate"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="时效性：" prop="timeliness" v-if="type == 1">
                            <el-input v-model="ruleForm.timeliness_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：" prop="approval_status">
                            <el-select
                                filterable
                                v-model="ruleForm.approval_status_label"
                                placeholder="请选择审批状态"
                                clearable
                                size="mini"
                                @change="approvalChange"
                            >
                                <el-option v-for="item in approvalOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="返利前单位底价下限：" prop="unit_base_price_before_rebate_lb">
                            <el-input
                                v-model="ruleForm.unit_base_price_before_rebate_lb"
                                size="mini"
                                placeholder="请输入返利前单位底价下限"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="返利类型：" prop="rebate_type">
                            <el-select
                                filterable
                                v-model="ruleForm.rebate_type_label"
                                placeholder="请选择返利类型态"
                                clearable
                                @change="rebateChange"
                                size="mini"
                            >
                                <el-option v-for="item in rebateOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单位返利上限：" prop="unit_rebate_ub">
                            <el-input
                                v-model="ruleForm.unit_rebate_ub"
                                size="mini"
                                placeholder="请输入单位返利上限"
                                type="number"
                                :min="0"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="代理类型：" prop="agency_type">
                            <el-select filterable v-model="ruleForm.agency_type" placeholder="请选择代理类型" clearable size="mini">
                                <el-option v-for="item in agencyOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="返利后单位底价下限：" prop="unit_base_price_after_rebate_lb" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.unit_base_price_after_rebate_lb"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="上次提交人职位：" prop="submission_hierarchy_name" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.submission_hierarchy_name"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：" prop="MEPR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.marginal_expense_provision_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="提交人职位：" prop="submission_hierarchy_rid">
                            <el-select
                                v-model="ruleForm.submission_hierarchy_rid"
                                placeholder="请选择职位等级"
                                clearable
                                style="width: 100%"
                                filterable
                            >
                                <el-option v-for="item in hierarchyOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="VATR：" prop="VATR" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.value_added_tax_rate"
                                size="mini"
                                class="flex_item_text"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="价格控制匹配条件：" prop="price_control_rid" v-if="type == 1">
                            <div class="read_only_link read_only" @click="priceClick(ruleForm.price_control_rid)">
                                {{ ruleForm.price_control_rid }}
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="" v-if="type == 1">
                            <div class="read_only"></div>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cooperationEdit',
    data() {
        return {
            btnLoading: false,
            partnerLoading: false,
            partnerOptions: [], //合作方列表
            productOptions: [], //产品列表
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            agencyOptions: [],
            //基本信息内表单验证
            ruleForm: {
                code: '',
                partner_rid: '',
                partner_name: '',
                product_rid: '',
                product_name: '',
                product_code: '',
                city_rid: '',
                city_name: '',
                province_rid: '',
                province_name: '',
                feature_code: '',
                start_date: '',
                end_date: '',
                timeliness: '',
                timeliness_label: '',
                approval_status: '2',
                approval_status_label: '2',
                unit_base_price_before_rebate_lb: '',
                rebate_type_label: '',
                rebate_type: '',
                unit_rebate_ub: '0',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                unit_base_price_after_rebate_lb: '',
                price_control_rid: '',
                updated_by: '',
                updated_at: '',
                created_by: '',
                created_at: '',
                agency_type: '',
                submission_hierarchy_rid: ''
            },
            hierarchyOptions: [],
            rules: {
                partner_name: [{ required: true, message: '请输入合作方', trigger: 'blur' }],
                product_name: [{ required: true, message: '请输入选择产品名称', trigger: 'blur' }],
                start_date: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
                end_date: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
                approval_status: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
                unit_base_price_before_rebate_lb: [
                    {
                        required: true,
                        message: '请输入返利前单位底价下限',
                        trigger: 'blur'
                    }
                ],
                rebate_type: [{ required: true, message: '请选择返利类型', trigger: 'blur' }],
                unit_rebate_ub: [{ required: true, message: '请输入单位返利上限', trigger: 'blur' }],
                agency_type: [{ required: true, message: '请选择', trigger: 'blur' }]
            },
            states: [],
            //审批状态列表
            approvalOptions: [
                {
                    value: '1',
                    label: '草稿'
                },
                {
                    value: '2',
                    label: '审批中'
                }
            ],
            //返利类型列表
            rebateOptions: [
                {
                    value: '1',
                    label: '价格'
                },
                {
                    value: '2',
                    label: '费用'
                }
            ],
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        // this.getHierarchies();
        this.getProduct(); //获取产品
        this.getProvinces(); //获取省份
        this.agencyType(); //代理类型
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {
                code: '',
                partner_rid: '',
                partner_name: '',
                product_rid: '',
                product_name: '',
                product_code: '',
                city_rid: '',
                city_name: '',
                province_rid: '',
                province_name: '',
                feature_code: '',
                start_date: '',
                end_date: '',
                timeliness: '',
                timeliness_label: '',
                approval_status_label: '2',
                approval_status: '2',
                unit_base_price_before_rebate_lb: '',
                rebate_type_label: '',
                rebate_type: '',
                unit_rebate_ub: '0',
                marginal_expense_provision_rate: '',
                value_added_tax_rate: '',
                unit_base_price_after_rebate_lb: '',
                price_control_rid: '',
                updated_by: '',
                updated_at: '',
                created_by: '',
                created_at: '',
                submission_hierarchy_rid: ''
            };
        }
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        //获取提交人职位
        // getHierarchies() {
        //     let params = {};
        //     this.$api
        //         .adminHierarchies(params)
        //         .then((res) => {
        //             if (res.code == 0) {
        //                 this.hierarchyOptions = res.data;
        //                 if (res.data.length != 0) {
        //                     this.ruleForm.submission_hierarchy_rid = res.data[0].value;
        //                 }
        //             }
        //         })
        //         .catch((error) => {
                    
        //         });
        // },
        agencyType() {
            let params = {};
            this.$api
                .agencyType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.agencyOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //查看价格控制
        priceClick(rid) {
            this.$router.push({
                path: 'priceControlDetail',
                query: {
                    id: rid
                }
            });
        },
        //查看产品详情
        productClick(rid) {
            this.$router.push({
                path: 'productListDetails',
                query: {
                    id: rid
                }
            });
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //省份改变请求当下省份下的城市
        provinceChange(val) {
            this.cityOptions = [];
            this.ruleForm.province_rid = val;
            if (val) {
                this.ruleForm.city_name = '';
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.ruleForm.city_name = '';
                this.cityOptions = [];
            }
        },
        //获取产品
        getProduct() {
            let params = {
                has_all: '0'
            };
            this.$api
                .dropdownProducts(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.productOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //开始时间框联动
        startChange(val) {
            this.ruleForm.start_date = val;
            this.ruleForm.end_date = '';
        },
        //结束时间框联动
        endDate(val) {
            if (val) {
                if (!this.ruleForm.start_date) {
                    this.$message({
                        message: '请先选择开始时间！',
                        type: 'warning'
                    });
                    this.ruleForm.end_date = '';
                } else {
                    let startTime = this.ruleForm.start_date.replace(/-/g, '');
                    let endTime = this.ruleForm.end_date.replace(/-/g, '');
                    if (endTime < startTime) {
                        this.$message({
                            message: '结束时间不能小于开始时间！',
                            type: 'warning'
                        });
                        this.ruleForm.end_date = '';
                    }
                }
            }
        },
        //返利类型框联动
        rebateChange(val) {
            this.ruleForm.rebate_type = val;
        },
        //审批状态框联动
        approvalChange(val) {
            this.ruleForm.approval_status = val;
        },
        //城市选择框联动
        cityChange(val) {
            this.ruleForm.city_rid = val;
            this.ruleForm.city_name = val;
        },
        //产品选择框联动
        productChange(val) {
            this.ruleForm.product_rid = val;
        },
        //合作方选择框联动
        partnerChange(val) {
            this.ruleForm.partner_rid = val;
        },
        //合作方搜索
        remotePartner(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.partnerLoading = false;
                                this.partnerOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/cooperationList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .partnerSchemeDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        res.data.submission_hierarchy_rid = this.ruleForm.submission_hierarchy_rid;
                        this.ruleForm = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                partner_rid: this.ruleForm.partner_rid,
                product_rid: this.ruleForm.product_rid,
                province_rid: this.ruleForm.province_rid,
                city_rid: this.ruleForm.city_rid,
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                approval_status: this.ruleForm.approval_status,
                unit_base_price_before_rebate_lb: this.ruleForm.unit_base_price_before_rebate_lb,
                rebate_type: this.ruleForm.rebate_type,
                unit_rebate_ub: this.ruleForm.unit_rebate_ub,
                rid: this.rid,
                agency_type: this.ruleForm.agency_type,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .partnerSchemeUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                partner_rid: this.ruleForm.partner_rid,
                product_rid: this.ruleForm.product_rid,
                province_rid: this.ruleForm.province_rid,
                city_rid: this.ruleForm.city_rid,
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
                approval_status: this.ruleForm.approval_status,
                unit_base_price_before_rebate_lb: this.ruleForm.unit_base_price_before_rebate_lb,
                rebate_type: this.ruleForm.rebate_type,
                unit_rebate_ub: this.ruleForm.unit_rebate_ub,
                agency_type: this.ruleForm.agency_type,
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid
            };
            this.btnLoading = true;
            this.$api
                .partnerSchemeInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>